import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LocalStorageService } from './services/local-storage.service';


@Component( {
  selector: 'app-root',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
} )
export class App implements OnDestroy
{
  constructor(
    private _localStorage: LocalStorageService
  )
    {
    } 
    ngOnDestroy(): void {
      this._localStorage.clear();
    }
}
